export interface NavigateAction {
	action: ActionNavigate;
	currentId: number;
	parentId: number;
}

export interface BackNavigation {
	action: ActionNavigate;
	controller: string;
	method: string;
	routeData: BackRouteData;
}

export interface BackRouteData {
	menuGroupId: number;
	parentMenuModifierGroupId: number;
	groupParentId: number;
}
export enum ActionNavigate {
	GetMenuItemsByGroupId = "GetMenuItemsByGroupId",
	GetModifierGroupsByParentId = "GetModifierGroupsByParentId",
	GetMenuModifiersByGroupId = "GetMenuModifiersByGroupId",
	GetMenuGroupByParentId = "GetMenuGroupByParentId"
}
